export default __webpack_public_path__ + "fc398e67da16bc356d768ed88c45256b.woff2";